export default {
  reviewCompleteHeader: 'Rivedi e completa',
  participants: 'Partecipanti',
  enterParticipantInfoText:
    'Informazioni sui partecipanti di questa esperienza',
  purchaser: 'Acquirente',
  firstName: 'Nome',
  lastName: 'Cognome',
  email: 'Email',
  optionalEmail: 'Email: (opzionale)',
  'phone:': 'Telefono',
  participantFieldPlaceholder:
    'Aggingi nuovo o seleziona partecipante esistente',
  reservationSummary: 'Riepilogo della prenotazione',
  editParticipantsDetails: 'Modifica dettagli partecipanti',
  participantDetails: 'Dettagli dei partecipanti',
  duplicatePurchaserText: "Come l'acquirente",
  phone: 'Telefono',
  addParticipant: 'Aggiungi {{tierLabel}}',
  participant: 'Partecipante',
  removeParticipant: 'Rimuovi',
  experienceCheckoutCompleted: "Checkout dell'esperienza completato",
  experienceCartCheckout: 'Carrello esperienza - Checkout',
  experienceLimitReached: 'Questa esperienza è al completo',
  payment: 'Pagamento',
  duration: 'Durata',
  discountCode: 'Codice sconto',
  removeCode: 'Rimuovi codice',
  invalidCodeValidation: 'Codice non valido',
  networkErrorDiscountCode: 'Qualcosa è andato storto',
  onlyOneCouponCodeAllowed: 'Solo un codice sconto è permesso',
  creditCodeHasAlreadyBeenApplied: 'Il codice credito è già stato applicato',
  discount: 'Sconto',
  promo: 'Promo',
  promoCode: 'Codice promozionale',
  apply: 'Applica',
  total: 'Totale',
  subTotal: 'Subtotale',
  includes: 'Includi',
  and: 'e',
  addHostNotes: 'Aggiungi note',
  brandAggreementText:
    'Oppure io certifico di essere stato autorizzato dal partecipante ad acconsentire a',
  termsAggreementValidation: 'Accetto i termini e condizioni',
  firstNameValidation: 'Nome è obbligatorio',
  lastNameValidation: 'Cognome è obbligatorio',
  emailValidation: {
    emailRequiredText: 'Email è obbligatorio',
    invalidEmail: 'Indirizzo email non valido',
    not_specified: 'Indirizzo email non corretto',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Telefono non valido',
    not_specified: 'Non valido',
    phoneRequiredText: 'Numero di telefono è obbligatorio',
  },
  participantFirstNameValidation: 'Nome del partecipante obbligatorio',
  participantLastNameValidation: 'Cognome del partecipante obbligatorio',
  complete: 'Completo',
  '404Message': 'Non trovato',
  waiting: 'Aspetta...',
  complimentary: 'Gratuito',
  confirmationHeader: 'La tua esperienza è prenotata!',
  confirmationText: 'Ti è stata inviata una mail con maggiori dettagli',
  viewAll: 'Vedi tutte le esperienze',
  paymentMethod: 'Metodo di pagamento',
  creditCard: 'Carta di credito',
  roomCharge: 'Carica sul conto della camera',
  memberCharge: 'Carica sulla tessera socio',
  roomOrReservationNumber:
    'Numero di camera o numero di conferma della prenotazione hotel',
  roomNumber: 'Numero di camera',
  roomNumberLegacy: 'Numero di camera o numero della prenotazione hotel',
  memberNumber: 'Numero membro',
  kicc: 'Paga facile',
  chargeValidation: 'Numero di camera e cognome obbligatorio',
  memberNumberValidation: 'Numero di membro richiesto',
  invalidRoomNumber: 'Numero di camera non valido',
  invalidRoomNumberLegacy:
    'Numero di camera o codice di prenotazione non valido',
  invalidMemberNumber: 'Numero membro invalido',
  invalidPhoneNumber: 'Numero di telefono non valido',
  guestNameIsRequired: 'Nome ospite obbligatorio',
  roomNumberIsRequired: 'Numero di camera obligatorio',
  roomNumberIsRequiredLegacy:
    'Numero di camera o codice di prenotazione obbligatorio',
  roomOrReservationNumberIsRequired:
    'Numero di camera o numero di prenotazione obbligatorio',
  cardNumberIncomplete: 'Numero di carta incompleto',
  lastNameValidationError: 'Cognome obbligatorio',
  isReqd: 'è obbligatorio',
  reservationCode: 'Prenotazione/numero di conferma',
  nonHotelGuest: "Non ospite dell'hotel",
  onPropertyGuest: "Ospite dell'hotel",
  preArrivalGuest: '?',
  cardNumber: 'Numero di carta',
  pmsValidationErrorMessage:
    'Cognome o numero di camera o numero di prenotazione non valido',
  pmsDateValidationErrorMessage:
    'Ops!La data della tua esperienza non coincide con arrivo e partenza',
  fullName: 'Nome e cognome',
  checkout: 'Partenza',
  editParticipants: 'Modifica partecipanti',
  private: 'Privato',
  browseAllExperieces: 'Esplora tutte le esperienze',
  payWithCreditCard: 'Paga con carta di credito',
  payWithRoomCharge: 'Paga con addebito in camera',
  payWithMemberCharge: 'Paga con la tessera socio',
  payWith: 'Paga con',
  bookBulkErrorByCard:
    'Si è verificato un problema durante la conferma della tua prenotazione. La tua carta non è stata addebitata.',
  bookBulkErrorByRoomCharge: 'Cognome e numero di camera non validi.',
  bookBulkErrorByMemberCharge: 'Cognome e numero cliente non validi.',
  reviewCancellation: 'Conferma cancellazione',
  selectAReservationToCancel: 'Seleziona una prenotazione da cancellare',
  confirmCancellation: 'Conferma cancellazione',
  cancellable: 'Cancellabile',
  cancelled: 'Cancellato',
  deadlinePassed: 'Scadenza superata',
  noCancellations: 'Non cancellabile',
  reviewReschedule: 'La tua prenotazione',
  selectAReservationToReschedule: 'Seleziona una prenotazione da riprogrammare',
  confirmReservation: 'Conferma prenotazione',
  confirm: 'Conferma',
  selectADateAndTime: 'Seleziona una data e un orario',
  noOtherSessionsAvailableForThisExperience:
    'Non ci sono altre sessioni disponibili per questa esperienza.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Questa prenotazione non può più essere riprogrammata. Si prega di inviare un email a {{brandEmail}}',
  thisReservationCannotBeRescheduled:
    'Questa prenotazione non può essere riprogrammata',
  noTimesAvailable: 'Nessun orario disponibile',
  noBookingsAvailable: 'Nessuna prenotazione disponibile',
  youPaid: 'Hai pagato',
  refund: 'Rimborso',
  yourRefund: 'Il tuo rimborso',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Il rimborso verrà elaborato sul metodo di pagamento originale.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    "Questa prenotazione non può più essere cancellata. Si prega di inviare un'email a {{bradnEmail}}",
  reservationCancelled: 'Prenotazione cancellata',
  thisReservationCannotBeCancelled:
    'Questa prenotazione non può essere cancellata',
  thisReservationHasAlreadyBeenCancelled:
    'Questa prenotazione è già stata cancellata',
  theHotel: "l'hotel",
  cancelling: 'Cancellazione',
  somethingWentWrong: 'Qualcosa è andato storto',
  previouslyRefunded: 'Precedentemente rimborsato',
  remainingBalance: 'Saldo rimanente',
  phoneNumber: 'Numero di telefono',
  requestToBookConfirmationText:
    'Un email di conferma è stato inviato a {{email}}',
  reservationRescheduled: 'Prenotazione riprogrammata',
  yourReservationWasRescheduledTo:
    'La tua prenotazione è stata riprogrammata per',
  viewExperiences: 'Vedi esperienze',
  joinBook: 'Unisciti e prenota',
  signInBook: 'Accedi e prenota',
  signAndJoin: 'Accedi o unisciti per prenotare',
  signAndJoinDescription:
    "Le esperienze World of Hyatt sono exclusive per i membri World of Hyatt. Accedi o unisciti per prenotare e guadagnare punti. Preferisci non unirti? Puoi sempre prenotare esperienze non exclusive rimuovendo l'esperienza World of Hyatt dal tuo carrello.",
  promoOrFind: 'Codice promozionale o codice credito FIND',
  hyattTermsAndConditions: 'Termini e condizioni',
  hyattTermsAndConditionsAgreement:
    'Confermando questa prenotazione, accetto la politica di cancellazione. Ho inoltre letto e riconosciuto l’uso delle mie informazioni personali in conformità con le',
  hyattTermsAndConditionsLink: 'Politiche sulla privacy di Hyatt',
  hyattWaiverText:
    'Acquistando questa esperienza, accetto, comprendo e riconosco, sia per mio conto che per conto di qualsiasi individuo che partecipa all’esperienza acquistata da me (se presente), quanto segue',
  hyattWaiverLink: 'esonero generale',
  priceDisclaimer: 'Includi le tasse prima delle tasse',
  curatedRecommendations: 'Consigli personalizzati',
  moreExperiencesYouMightLike: 'Altre esperienze che potresti apprezzare',
  similarExperiencesAvailableToBookDirectly:
    'Esperienze simili disponibili per prenotazione diretta',
  experiencesAvailableAroundYourBookingDate:
    'Esperienze disponibili intorno alla tua data di prenotazione',
  confirmationEmailSent:
    'Abiamo inviato la tua conferma a {{email}} con maggiori dettagli.',
  youreBooked: 'Sei prenotato',
  purchaserInformation: "Informazioni dell'acquirente",
  requiredFieldIndicator: '* indica un campo obbligatorio',
  resourceSelectionTitle: 'Scegli le tue opzioni',
  resourceSelectionDescription:
    "Scegli un'opzione per ogni elemento della prenotazione.",
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Seleziona {{attributeName}}',
  resourceValueSoldOut: '{{label}} (esaurito)',
  resourceValueUnavailableWith: '{{label}} (non disponibile con {{picks}})',
  resourceOptionsUnavailable:
    'Non è stato possibile caricare le opzioni per questo orario. Riprova.',
  resourceOptionsRetry: 'Riprova',
  changeResourceSelections: 'Modifica le tue scelte',
};
